import { PODIUM_WORDMARK_PATHS, PODIUM_WORDMARK_VIEWBOX } from '@/components/brand/podium-wordmark-paths'
import { cn } from '@/lib/utils'

type WordmarkProps = {
  className?: string
  height?: number
  variant?: 'light' | 'dark'
  'aria-hidden'?: boolean
}

export function PodiumWordmark({
  className,
  height = 28,
  variant = 'dark',
  'aria-hidden': ariaHidden,
}: WordmarkProps) {
  const fill =
    variant === 'light' ? 'var(--color-wordmark-light)' : 'var(--color-wordmark-dark)'
  const width = (height / PODIUM_WORDMARK_VIEWBOX.height) * PODIUM_WORDMARK_VIEWBOX.width

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${PODIUM_WORDMARK_VIEWBOX.width} ${PODIUM_WORDMARK_VIEWBOX.height}`}
      width={width}
      height={height}
      fill="none"
      className={cn('shrink-0', className)}
      role={ariaHidden ? undefined : 'img'}
      aria-hidden={ariaHidden}
      aria-label={ariaHidden ? undefined : 'Podium Markets'}
    >
      {PODIUM_WORDMARK_PATHS.map((d) => (
        <path key={d.slice(0, 24)} fill={fill} d={d} />
      ))}
    </svg>
  )
}

export function PodiumMark({ className, size = 44 }: { className?: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('shrink-0', className)}
      aria-hidden
    >
      <path d="M13.9412 8.05884H8.05884V21H13.9412V8.05884Z" fill="currentColor" />
      <path d="M21 10.4117H15.1176V21H21L21 10.4117Z" fill="currentColor" />
      <path d="M6.88235 10.4117H1V21H6.88235L6.88235 10.4117Z" fill="currentColor" />
      <path
        d="M12.9578 1H9.04218C8.49735 1 8.05884 1.43819 8.05884 1.98261V6.88235L9.52943 5.41287H12.9623C13.5027 5.41287 13.9412 4.97468 13.9412 4.43469V1.98261C13.9412 1.43819 13.4982 1 12.9578 1Z"
        fill="currentColor"
      />
    </svg>
  )
}
